import React from "react";
import cn from "classnames";
import SvgIcon from "../../../../common/components/svg-icon";

const NoData = ({ runAI, text, regionName, noRegions = false, working = false }) => {
  const title = noRegions ? "BuzzIQ Summary" : `BuzzIQ Summary - ${regionName}`;

  return (
    <>
      <div className={ cn("middle", { "-no-margin": !noRegions }) }>
        <h3>{ title }</h3>
        <span>{text}</span>
      </div>
      {
        noRegions &&
        <button
          type="button"
          className="button run-button"
          disabled
        >
          Run
        </button>
      }
      {
        !noRegions && !working &&
        <div className="buttons">
          <a className="link" onClick={ runAI }>
            <SvgIcon name="refresh-nocolor" />
            Create Summary
          </a>
        </div>
      }
    </>
  );
};

export default NoData;
